import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const WarningIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path
        fillRule="evenodd"
        d="M10.48 2.4a3 3 0 0 1 4.12 1.1l8 14A3 3 0 0 1 20 22H4a3 3 0 0 1-2.62-4.5l8-14a3 3 0 0 1 1.1-1.1Zm1.51 1.59a1 1 0 0 0-.87.5l-8 14.01a1 1 0 0 0 .87 1.5H20a1 1 0 0 0 .86-1.5l-8-14a1 1 0 0 0-.87-.51Z"
        clipRule="evenodd"
      />
      <path
        fillRule="evenodd"
        d="M12 8a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1Zm-1 9a1 1 0 0 1 1-1h.01a1 1 0 0 1 0 2H12a1 1 0 0 1-1-1Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default WarningIcon;
